import { render, staticRenderFns } from "./OrderConfirm.vue?vue&type=template&id=320a5cc8&scoped=true&"
import script from "./OrderConfirm.vue?vue&type=script&lang=ts&"
export * from "./OrderConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./OrderConfirm.vue?vue&type=style&index=0&id=320a5cc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a5cc8",
  null
  
)

export default component.exports